module.exports = __webpack_public_path__ + "img/color_rosegold_a-1755-1@2x.b8304c3.webp";